/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 493);
/******/ })
/************************************************************************/
/******/ ({

/***/ 3:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**

 * Generic JavaScript for IPP - v1.0 Chris Salt
 * 13/03/2014
 */



__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {

    var reformatSitsErrors;

    /*********************************************************************/
    /* FUNCTION DECLARATIONS                                             */
    /*********************************************************************/
    reformatSitsErrors = function reformatSitsErrors() {
        var messageTitle = void 0;
        var messageContent = void 0;
        var $messageBox = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.sv-message-box');

        //Find any sits error, hide and output Bootstrap styled error
        messageTitle = $messageBox.find('.sv-panel-heading').text();
        messageContent = $messageBox.find('.sv-panel-body').html();

        $messageBox.empty().removeClass('sv-panel sv-panel-danger').addClass('alert alert-danger').append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('<p>', { 'id': 'newmessagetitle' }).append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('<strong>').html('<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ' + messageTitle)));
        $messageBox.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('<p>', { 'id': 'newmessagecontent' }).html(messageContent));
    };

    /*********************************************************************/
    /* EVENTS                                                            */
    /*********************************************************************/

    /*********************************************************************/
    /* RUN                                                               */
    /*********************************************************************/
    reformatSitsErrors();
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// ku/js/ola_general.js